module.exports = __webpack_public_path__ + "img/minus_btn.7c1e052d.png";